import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vip",
  "use": "icon-vip-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-vip\"><defs><style type=\"text/css\"></style></defs><path d=\"M119.466667 221.866667L298.666667 341.333333l178.602666-250.026666a42.666667 42.666667 0 0 1 69.461334 0L725.333333 341.333333l179.2-119.466666a42.666667 42.666667 0 0 1 66.005334 40.533333l-70.101334 595.925333a42.666667 42.666667 0 0 1-42.368 37.674667H165.930667a42.666667 42.666667 0 0 1-42.368-37.674667L53.461333 262.357333A42.666667 42.666667 0 0 1 119.466667 221.866667zM512 640a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z\" p-id=\"59289\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/vip.svg
// module id = x9ib
// module chunks = 7